import {
  KoButton,
  KoDrawer,
  KoLoader,
  KoSelect,
  KoInput,
  KoTable,
  // KoText,
  // KoTitle,
  KoTag,
  KoEmpty,
  KoPagination
} from 'packages';
import KoIcon from '@kwapio/icons';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { add, remove } from 'shared/store/breadcrumbSlice';
import KoToolBar from 'shared/components/toolbar';
import { MonitoringAPI } from '../services/monitoring.service';
import {
  COLUMNS_LOGS,
  LOG_LEVEL_CONFIG,
  TIME_RANGE_OPTIONS,
  ENVIRONMENT_OPTIONS
} from '../constants';
import MonitoringSubNav from './MonitoringSubNav';
import styles from './monitoring.module.scss';

const LOG_LEVEL_OPTIONS = [
  { label: 'DEBUG', value: 'debug' },
  { label: 'INFO', value: 'info' },
  { label: 'WARN', value: 'warn' },
  { label: 'ERROR', value: 'error' },
  { label: 'FATAL', value: 'fatal' }
];

const MOCK_SERVICE_LIST = [
  { label: 'api-gateway', value: 'svc-001' },
  { label: 'auth-service', value: 'svc-002' },
  { label: 'payment-processor', value: 'svc-003' },
  { label: 'notification-hub', value: 'svc-004' },
  { label: 'search-engine', value: 'svc-006' },
  { label: 'analytics-pipeline', value: 'svc-008' }
];

const MOCK_LOGS = [
  { _id: 'log-001', timestamp: '2026-02-24T10:32:15.234Z', level: 'error', service: 'payment-processor', message: 'Connection pool exhausted: max connections (500) reached for db-primary', traceId: 'tr-8f2a3c4d5e6f', spanId: 'sp-001', userId: 'usr-4521', method: 'POST', endpoint: '/v4/payments/charge', statusCode: 503, durationMs: 5230, stacktrace: 'Error: Connection pool exhausted\n  at Pool.acquire (pool.js:142)\n  at PaymentService.processCharge (payment.js:89)' },
  { _id: 'log-002', timestamp: '2026-02-24T10:32:14.891Z', level: 'warn', service: 'api-gateway', message: 'Rate limit approaching: 450/500 requests in current window for client app-mobile-ios', traceId: 'tr-1a2b3c4d5e6f', spanId: 'sp-002', method: 'GET', endpoint: '/v3/users/me', statusCode: 200, durationMs: 45 },
  { _id: 'log-003', timestamp: '2026-02-24T10:32:12.567Z', level: 'info', service: 'auth-service', message: 'Token refresh successful for user usr-7823, new expiry: 2026-02-24T11:32:12Z', traceId: 'tr-2b3c4d5e6f7g', spanId: 'sp-003', userId: 'usr-7823', method: 'POST', endpoint: '/v3/auth/refresh', statusCode: 200, durationMs: 120 },
  { _id: 'log-004', timestamp: '2026-02-24T10:32:10.123Z', level: 'error', service: 'search-engine', message: 'Index rebuild failed: insufficient disk space on node search-03 (92% used)', traceId: 'tr-3c4d5e6f7g8h', spanId: 'sp-004', statusCode: 500, durationMs: 15200, stacktrace: 'Error: ENOSPC: no space left on device\n  at IndexManager.rebuild (index.js:234)' },
  { _id: 'log-005', timestamp: '2026-02-24T10:32:08.456Z', level: 'info', service: 'notification-hub', message: 'Email batch sent successfully: 150 transactional emails delivered via SendGrid', traceId: 'tr-4d5e6f7g8h9i', spanId: 'sp-005', method: 'POST', endpoint: '/v1/notifications/batch', statusCode: 200, durationMs: 3400 },
  { _id: 'log-006', timestamp: '2026-02-24T10:32:05.789Z', level: 'debug', service: 'analytics-pipeline', message: 'Event batch processed: 2,450 events ingested, 3 dropped (schema validation)', traceId: 'tr-5e6f7g8h9i0j', spanId: 'sp-006', durationMs: 890 },
  { _id: 'log-007', timestamp: '2026-02-24T10:32:03.012Z', level: 'warn', service: 'payment-processor', message: 'Retry attempt 2/3 for payment txn-98234: gateway timeout on stripe webhook', traceId: 'tr-6f7g8h9i0j1k', spanId: 'sp-007', userId: 'usr-1234', method: 'POST', endpoint: '/v4/payments/webhook', statusCode: 504, durationMs: 30000 },
  { _id: 'log-008', timestamp: '2026-02-24T10:32:01.345Z', level: 'info', service: 'api-gateway', message: 'Health check passed: all 10 upstream services responding within SLA', traceId: 'tr-7g8h9i0j1k2l', spanId: 'sp-008', method: 'GET', endpoint: '/health', statusCode: 200, durationMs: 12 },
  { _id: 'log-009', timestamp: '2026-02-24T10:31:58.678Z', level: 'fatal', service: 'search-engine', message: 'OOM killed: search-engine-pod-3 exceeded memory limit (4Gi), restarting', traceId: 'tr-8h9i0j1k2l3m', spanId: 'sp-009', stacktrace: 'Fatal: JavaScript heap out of memory\n  at Array.sort (<anonymous>)\n  at QueryEngine.execute (query.js:567)' },
  { _id: 'log-010', timestamp: '2026-02-24T10:31:55.901Z', level: 'info', service: 'auth-service', message: 'OAuth2 callback processed: Google SSO login for user usr-9012', traceId: 'tr-9i0j1k2l3m4n', spanId: 'sp-010', userId: 'usr-9012', method: 'GET', endpoint: '/v3/auth/callback/google', statusCode: 302, durationMs: 250 }
];

function LogExplorer() {
  const dispatch = useDispatch();
  const { workspaceId } = useParams();

  const [logs, setLogs] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ size: 50, page: 1 });

  const [filters, setFilters] = useState({
    service: null,
    environment: null,
    level: null,
    timeRange: '1h',
    traceId: '',
    search: ''
  });

  const [serviceList, setServiceList] = useState([]);
  const [selectedLog, setSelectedLog] = useState(null);
  const [isDrawerOpen, setDrawerOpen] = useState(false);

  const basePath = workspaceId
    ? `/workspace/${workspaceId}/development/monitoring`
    : '/monitoring';

  useEffect(() => {
    dispatch(remove());
    dispatch(add([
      { title: 'Home', path: 'home/myoverview' },
      { title: 'Monitoring', path: basePath },
      { title: 'Log Explorer' }
    ]));
    fetchServiceList();
  }, [workspaceId]);

  useEffect(() => {
    fetchLogs();
  }, [workspaceId, pagination, filters]);

  const fetchServiceList = () => {
    MonitoringAPI.getServiceList().then(
      (data) => {
        const list = (data?.data || data || []).map(s => ({
          label: s.serviceName || s.name,
          value: s.serviceId || s._id
        }));
        setServiceList(list.length ? list : MOCK_SERVICE_LIST);
      },
      () => setServiceList(MOCK_SERVICE_LIST)
    );
  };

  const fetchLogs = () => {
    setLoading(true);
    const params = {
      page: pagination.page,
      limit: pagination.size,
      timeRange: filters.timeRange,
      ...(filters.service && { service: filters.service }),
      ...(filters.environment && { environment: filters.environment }),
      ...(filters.level && { level: filters.level }),
      ...(filters.traceId && { traceId: filters.traceId }),
      ...(filters.search && { search: filters.search })
    };
    MonitoringAPI.searchLogs(params).then(
      (res) => {
        const data = res?.data?.length ? res.data : MOCK_LOGS;
        setLogs(data);
        setTotalCount(res?.totalCount || data.length);
        setLoading(false);
      },
      () => { setLogs(MOCK_LOGS); setTotalCount(MOCK_LOGS.length); setLoading(false); }
    );
  };

  const updateFilter = (key, value) => {
    setFilters(prev => ({ ...prev, [key]: value }));
    setPagination(p => ({ ...p, page: 1 }));
  };

  const clearFilters = () => {
    setFilters({ service: null, environment: null, level: null, timeRange: '1h', traceId: '', search: '' });
    setPagination(p => ({ ...p, page: 1 }));
  };

  const openLogDetail = (record) => {
    setSelectedLog(record);
    setDrawerOpen(true);
  };

  return (
    <div className='tableCard'>
      {isLoading && <KoLoader />}
      <MonitoringSubNav activeKey='logs' />

      <KoToolBar
        title='Log Explorer'
        search={{
          visible: true,
          placeholder: 'Search logs...',
          onChange: (val) => updateFilter('search', val)
        }}
        filter={{ visible: false, options: [] }}
        buttonList={[
          {
            label: 'Refresh',
            icon: <KoIcon color='#565555' name='ReloadOutlined' width={16} height={16} />,
            onClick: fetchLogs
          }
        ]}
      />

      {/* Filter Bar */}
      <div className={styles.filterBar}>
        <KoSelect
          className={styles.filterItem}
          value={filters.service}
          onChange={(val) => updateFilter('service', val)}
          placeholder='Service'
          options={serviceList}
          allowClear
          style={{ minWidth: 160 }}
        />
        <KoSelect
          className={styles.filterItem}
          value={filters.environment}
          onChange={(val) => updateFilter('environment', val)}
          placeholder='Environment'
          options={ENVIRONMENT_OPTIONS}
          allowClear
          style={{ minWidth: 140 }}
        />
        <KoSelect
          className={styles.filterItem}
          value={filters.level}
          onChange={(val) => updateFilter('level', val)}
          placeholder='Log Level'
          options={LOG_LEVEL_OPTIONS}
          allowClear
          style={{ minWidth: 120 }}
        />
        <KoSelect
          className={styles.filterItem}
          value={filters.timeRange}
          onChange={(val) => updateFilter('timeRange', val)}
          options={TIME_RANGE_OPTIONS}
          style={{ minWidth: 140 }}
        />
        <KoInput
          placeholder='Trace ID'
          value={filters.traceId}
          onChange={(e) => updateFilter('traceId', e.target.value)}
          style={{ minWidth: 200, maxWidth: 280 }}
          allowClear
        />
        <KoButton label='Clear' onClick={clearFilters} />
      </div>

      {logs.length === 0 && !isLoading && (
        <KoEmpty description='No logs found for the selected filters' />
      )}

      {logs.length > 0 && (
        <>
          <KoTable
            maxHeight={480}
            dataSource={logs}
            columns={COLUMNS_LOGS}
            rowKey={(row) => row.logId || row._id || row.traceId}
            onRow={(record) => ({
              onClick: () => openLogDetail(record)
            })}
          />
          <KoPagination
            totalCount={totalCount}
            pageSize={pagination.size}
            currentPage={pagination.page}
            onChange={(page, size) => setPagination({ page, size })}
          />
        </>
      )}

      {/* Log Detail Drawer */}
      <KoDrawer
        title='Log Detail'
        open={isDrawerOpen}
        onClose={() => { setDrawerOpen(false); setSelectedLog(null); }}
        width={'min(600px, 95vw)'}
      >
        {selectedLog && (
          <div>
            <div className={styles.logMetaGrid}>
              <div className={styles.logMetaItem}>
                <span className={styles.logDetailLabel}>Timestamp</span>
                <span className={styles.logDetailValue}>{selectedLog.timestamp}</span>
              </div>
              <div className={styles.logMetaItem}>
                <span className={styles.logDetailLabel}>Level</span>
                <KoTag color={LOG_LEVEL_CONFIG[selectedLog.level]?.color}>
                  {LOG_LEVEL_CONFIG[selectedLog.level]?.label || selectedLog.level}
                </KoTag>
              </div>
              <div className={styles.logMetaItem}>
                <span className={styles.logDetailLabel}>Service</span>
                <span className={styles.logDetailValue}>{selectedLog.service}</span>
              </div>
              <div className={styles.logMetaItem}>
                <span className={styles.logDetailLabel}>Environment</span>
                <span className={styles.logDetailValue}>{selectedLog.environment}</span>
              </div>
              <div className={styles.logMetaItem}>
                <span className={styles.logDetailLabel}>Version</span>
                <span className={`${styles.logDetailValue} ${styles.monoSmall}`}>{selectedLog.version || '—'}</span>
              </div>
              <div className={styles.logMetaItem}>
                <span className={styles.logDetailLabel}>Release ID</span>
                <span className={`${styles.logDetailValue} ${styles.monoSmall}`}>{selectedLog.releaseId || '—'}</span>
              </div>
              <div className={styles.logMetaItem}>
                <span className={styles.logDetailLabel}>Trace ID</span>
                <span className={`${styles.logDetailValue} ${styles.monoSmall}`}>{selectedLog.traceId || '—'}</span>
              </div>
              <div className={styles.logMetaItem}>
                <span className={styles.logDetailLabel}>Span ID</span>
                <span className={`${styles.logDetailValue} ${styles.monoSmall}`}>{selectedLog.spanId || '—'}</span>
              </div>
              {selectedLog.endpoint && (
                <div className={styles.logMetaItem}>
                  <span className={styles.logDetailLabel}>Endpoint</span>
                  <span className={`${styles.logDetailValue} ${styles.monoSmall}`}>
                    {selectedLog.method} {selectedLog.endpoint}
                  </span>
                </div>
              )}
              {selectedLog.statusCode && (
                <div className={styles.logMetaItem}>
                  <span className={styles.logDetailLabel}>Status Code</span>
                  <span className={styles.logDetailValue}>{selectedLog.statusCode}</span>
                </div>
              )}
              {selectedLog.durationMs != null && (
                <div className={styles.logMetaItem}>
                  <span className={styles.logDetailLabel}>Duration</span>
                  <span className={styles.logDetailValue}>{selectedLog.durationMs}ms</span>
                </div>
              )}
              {selectedLog.userId && (
                <div className={styles.logMetaItem}>
                  <span className={styles.logDetailLabel}>User ID</span>
                  <span className={`${styles.logDetailValue} ${styles.monoSmall}`}>{selectedLog.userId}</span>
                </div>
              )}
            </div>

            <div className={styles.logDetailSection}>
              <div className={styles.logDetailLabel}>Message</div>
              <div className={styles.logMessage}>{selectedLog.message}</div>
            </div>

            {selectedLog.stacktrace && (
              <div className={styles.logDetailSection}>
                <div className={styles.logDetailLabel}>Stack Trace</div>
                <div className={styles.stackTrace}>{selectedLog.stacktrace}</div>
              </div>
            )}
          </div>
        )}
      </KoDrawer>
    </div>
  );
}

export default LogExplorer;
